export const ROLES = {
    ENERGY_EFFICIENCY_ROLES: ['SERVICE_ALL', 'CEVOLVER', 'OPTEMUS'],
    TOOLKIT_ROLES: ['SERVICE_ALL', 'ROLE_USER'],
    DOCUMENTATION_ROLES: ['SERVICE_ALL', 'DOCUMENTATION'],
    BETA_ROLES: ['BETA_USER']
};
